module.exports = __webpack_public_path__ + "static/media/package_develop_backend.241af36f.svg";